import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import logo from '../assets/Logo.png';
import bgImage from '../assets/bg-image.jpg'; // Optional background image

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-split-container">
      {/* Left side - background image with overlay text */}
      <div className="home-left">
        <div className="overlay">
          <h1 className="home-heading">
            Built to Manage<br />Designed to Empower
          </h1>
        </div>
      </div>

      {/* Right side - logo, subtitle, buttons */}
      <div className="home-right">
        <div className="home-content">
          <img src={logo} alt="CSC Logo" className="home-logo" />

       

          <div className="button-container">
            <button className="btn login-btn" onClick={() => navigate('/login')}>
              Sign In
            </button>
            <button className="btn register-btn" onClick={() => navigate('/register')}>
              Sign Up
            </button>
          </div>

          <h2 className="home-subtitle">Your Gateway to Seamless Learning</h2>

          <footer className="footer">
            <p>© 2025 CSC Learning Management System. Empowering Education.</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
